import React, { Fragment } from 'react'
import SbEditable from 'storyblok-react'
import ArticleStackedTeaser from 'gatsby-theme-kn/src/components/atoms/ArticleStackedTeaser'
import Headline from 'gatsby-theme-kn/src/components/atoms/Headline'
import Slider from 'react-slick'
import { useStaticQuery, graphql } from 'gatsby'

const ArticleTripleTeaserBlock = ({
  block,
  className,
  data_source,
  hideDate,
}) => {
  const data = useStaticQuery(graphql`
    query ArticlesQuery {
      de: allStoryblokEntry(
        filter: {
          parent_id: { in: [184923977, 184923986, 184924134] }
          field_component: { in: ["article_page", "content_page"] }
          field_hidden_on_startpage_boolean: { ne: true }
        }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            field_date_string
            content
          }
        }
      }
      en: allStoryblokEntry(
        filter: {
          parent_id: { in: [184924556, 184924560, 184924742] }
          field_component: { in: ["article_page", "content_page"] }
          field_hidden_on_startpage_boolean: { ne: true }
        }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            field_date_string
            content
          }
        }
      }
      fr: allStoryblokEntry(
        filter: {
          parent_id: { in: [184924971, 184924974, 184925189] }
          field_component: { in: ["article_page", "content_page"] }
          field_hidden_on_startpage_boolean: { ne: true }
        }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            field_date_string
            content
          }
        }
      }
      nl: allStoryblokEntry(
        filter: {
          parent_id: { in: [184925386, 184925390, 184925557] }
          field_component: { in: ["article_page", "content_page"] }
          field_hidden_on_startpage_boolean: { ne: true }
        }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            field_date_string
            content
          }
        }
      }
    }
  `)

  let lang

  if (typeof window !== 'undefined') {
    lang = window.location.pathname.split('/')[1]
  }

  let articles = data[lang]?.edges

  // Optional filtering of articles based on categories

  let filteredArticles = []

  if (!data_source && articles?.length > 0) {
    if (block.category_filter?.length > 0) {
      filteredArticles = articles.filter(
        (article) =>
          block.category_filter.indexOf(article.node.field_category_string) !==
          -1
      )
    } else {
      filteredArticles = articles
    }
    if (filteredArticles?.length > 0) {
      if (
        block?.teaser_limit &&
        (block?.teaser_limit !== 'unlimited' || block?.teaser_limit !== '')
      ) {
        filteredArticles.splice(parseInt(block.teaser_limit))
      } else {
        filteredArticles.splice(parseInt(6))
      }
    }
  }

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    mobileFirst: true,
    infinite: false,
    appendDots: (dots) => <ul> {dots} </ul>,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <SbEditable content={block}>
      <section
        className={`triple-teaser-block article-triple-teaser-block ${className} ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <div className="triple-teaser-block-container">
          <div
            className="triple-teaser-block-wrapper"
            // data-rellax-center={true}
            // data-rellax-speed={-1}
          >
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              subheadline={block.subheadline}
            />
            {typeof window !== 'undefined' && window.storyblok?.inEditor && (
              <div
                className=""
                style={{
                  backgroundColor: '#09b3af',
                  color: '#ffffff',
                  padding: '1rem',
                  marginBottom: '2rem',
                }}
              >
                <p className="" style={{ marginBottom: '0px' }}>
                  <h3 style={{ marginBottom: '1rem' }}>Hinweis:</h3>
                  <b>News-Teaser:</b> Die Daten der News stehen in der{' '}
                  <i>Vorschau</i> nicht zur Verfügung und können deshalb nicht
                  dargestellt werden.
                </p>
              </div>
            )}
            <Slider
              className="triple-teaser-block-row triple-teaser article-triple-teaser-block-row justify-content-start"
              {...settings}
            >
              {filteredArticles &&
                filteredArticles?.map((item, index) => (
                  <>
                    <ArticleStackedTeaser
                      item={item}
                      lang={lang}
                      key={index}
                      hideDate={hideDate}
                    />
                  </>
                ))}
              {data_source &&
                data_source?.map((item, index) => (
                  <ArticleStackedTeaser
                    item={item}
                    key={index}
                    hideDate={hideDate}
                  />
                ))}
            </Slider>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ArticleTripleTeaserBlock
